import Dialog from "@mui/material/Dialog";
import { Form, Formik, FormikHelpers } from "formik";
// import { showToast } from "src/utils/showToaster";
import { object, string } from "yup";
import ChangePasswordDialogForm, { ChangeAdminPasswordValues } from "./ChangePasswordDialogForm";
import { useAdminChangePasswordMutation } from "src/services/UserServices";
import { showToast } from "src/utils/showToaster";

type Props = {
  onClose: () => void;
  selectedUserId:string;
};

const ChangePasswordDialogFormWrapper = ({ onClose , selectedUserId }: Props) => {

    const [changePassword] = useAdminChangePasswordMutation()
  

  // Form Initial Values
  const initialValues: ChangeAdminPasswordValues = {
    confirmPassword: "",
    newPassword: "",
  };

  // Validation Schema
  const validationSchema = object().shape({
    confirmPassword: string().required("Please enter current password"),
    newPassword: string().required("Please enter new password"),
  });

  // Handle Submit
  const handleSubmit = (
    values: ChangeAdminPasswordValues,
    { setSubmitting, resetForm }: FormikHelpers<ChangeAdminPasswordValues>
  ) => {
    changePassword({
        body : values ,
        userId:selectedUserId ,
    }).then((res: any) => {
      if (res?.error) {
        showToast("error", res?.error?.data?.message);
      } else {
        if (res?.data?.status) {
          showToast("success", res?.data?.message);
          resetForm();
          onClose();
        } else {
          showToast("error", res?.data?.message);
        }
      }
      setSubmitting(false);
    });
  };

  return (
    <Dialog open maxWidth="xs" fullWidth>
      <Formik
        enableReinitialize
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {(formikProps) => (
          <Form>
            <ChangePasswordDialogForm
              formikProps={formikProps}
              onClose={onClose}
              formType="EDIT"
            />
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default ChangePasswordDialogFormWrapper;
